import React from "react";
import { editbtn } from "../atoms/lattice";
import {
  useRecoilValue
} from "recoil";

import "react-quill/dist/quill.snow.css";
import { currentJobLevel } from "../atoms/dashboard";
import { useLocation } from "react-router-dom";

export const Roleinfo = (props, values) => {
  const editBtnVal = useRecoilValue(editbtn);
  const currentJobLvlData = useRecoilValue(currentJobLevel);

  const { pathname } = useLocation();

  return (
    <div>
      <div className="inner-data-container dynamic-data">
        <h3
          className={`${(currentJobLvlData == "upcoming" && pathname.includes('dashboard')) ? "!text-[#009f4f]" : ""
            } text-sm font-medium`}
        >
          {"Role Description"}
        </h3>
        <div dangerouslySetInnerHTML={{ __html: `<pre>`+props?.details?.desc+`</pre>` }} />      
        <h3
          className={`${(currentJobLvlData == "upcoming" && pathname.includes('dashboard')) ? "!text-[#009f4f]" : ""
            } text-sm font-medium`}
        >
          {"Responsibilities"}
        </h3>
        <div dangerouslySetInnerHTML={{ __html:  `<pre>`+props?.details?.resp+`</pre>` }} />
       
      </div>
    </div>
  );
};
